export default __webpack_public_path__ + "static/media/logo_en.6660e5bb.png";